// Config
import axiosRequestConfig from './axios';

// Service
import BaseService from './service';

class SsoService extends BaseService {
  constructor() {
    super(axiosRequestConfig);
  }
}

export default SsoService;
